export default function getNationalAverage(activeProcedure) {
  switch (activeProcedure) {
    case 'Coronary artery bypass grafting (CABG)':
      return 48;
    case 'Laparoscopic cholecystectomy':
      return 31;
    case 'Open colectomy':
      return 34;
    case 'Lumpectomy':
      return 28;
    case 'Meniscectomy':
      return 41;
    case 'Minimally invasive procedure (MIP) hysterectomy':
      return 34;
    case 'Prostatectomy':
      return 33;
    default:
      return undefined;
  }
}
